(function () {
  'use strict';

  function initCarousel(section) {
    var track = section.querySelector('[data-rway-track]');
    var prevBtn = section.querySelector('[data-rway-prev]');
    var nextBtn = section.querySelector('[data-rway-next]');
    var dots = section.querySelectorAll('[data-rway-dot]');
    var cards = section.querySelectorAll('[data-rway-card]');
    if (!track || !cards.length) return;

    function scrollToIndex(index) {
      var card = cards[index];
      if (!card) return;
      track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    function currentIndex() {
      var trackLeft = track.scrollLeft;
      var closest = 0;
      var closestDist = Infinity;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.offsetLeft - track.offsetLeft - trackLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    function updateDots() {
      var idx = currentIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var idx = Math.max(0, currentIndex() - 1);
        scrollToIndex(idx);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var idx = Math.min(cards.length - 1, currentIndex() + 1);
        scrollToIndex(idx);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-index'), 10) || 0;
        scrollToIndex(idx);
      });
    });

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimeout);
      scrollTimeout = window.setTimeout(updateDots, 100);
    });
  }

  function init() {
    document.querySelectorAll('.rway').forEach(function (section) {
      initCarousel(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
